// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/unusual-attitude-recovery.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/unusual-attitude-recovery/unusual-attitude-recovery.js';

mount([g0]);
